export const DRAG = 'drag';
export const HOVER = 'hover';
export const SELECTIONDRAG = 'selectiondrag';
export const CLICK = 'click';
